import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import { dogs as staticDogs } from '../data/dogs'; // Fallback for dev

function DogsGrid() {
  const [dogs, setDogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDogs() {
      try {
        const { data, error } = await supabase.from('dogs').select('*');
        
        if (error) {
          console.error('Error fetching dogs from Supabase:', error);
          // Fallback to static data if not connected
          setDogs(staticDogs);
        } else if (data && data.length > 0) {
          setDogs(data);
        } else {
          // If no data, use static data for demo purposes
          setDogs(staticDogs);
        }
      } catch (err) {
        console.error('Error in fetch:', err);
        setDogs(staticDogs);
      } finally {
        setLoading(false);
      }
    }

    fetchDogs();
  }, []);

  return (
    <section className="section container" id="i-nostri-cani">
      <h2 className="section-title">I nostri cani in cerca di casa</h2>
      <p className="section-subtitle">Ognuno di loro ha un passato alle spalle, ma sta solo aspettando l'opportunità di dimostrarti tutto il suo amore.</p>
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>Caricamento...</div>
      ) : (
        <div className="dogs-grid">
          {dogs.map(dog => (
            <div className="dog-card animate-on-scroll" key={dog.id} style={{ position: 'relative' }}>
              <img src={dog.image} alt={dog.name} className="dog-image" />
              {dog.is_adopted && (
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '-10px',
                  backgroundColor: '#c62828',
                  color: 'white',
                  padding: '8px 32px',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  letterSpacing: '2px',
                  transform: 'rotate(45deg) translate(30px, -20px)',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                  zIndex: 2
                }}>
                  ADOTTATO
                </div>
              )}
              <div 
                className={`dog-info ${!(dog.bg && (dog.bg.startsWith('#') || dog.bg.startsWith('rgb'))) ? (dog.bg || 'bg-beige') : ''}`}
                style={dog.bg && (dog.bg.startsWith('#') || dog.bg.startsWith('rgb')) ? { backgroundColor: dog.bg } : {}}
              >
                <h3 className="dog-name">{dog.name}</h3>
                <div className="dog-tags">
                  <span className="tag">{dog.age}</span>
                  <span className="tag">{dog.size}</span>
                </div>
                <p style={{ fontSize: '14px', marginBottom: '8px' }}><strong>Carattere:</strong> {dog.character}</p>
                <p style={{ fontSize: '14px', marginBottom: '16px', color: 'var(--color-primary-dark)' }}>{dog.status}</p>
                
                <div className="dog-actions">
                  <button 
                    className="btn btn-secondary"
                    onClick={() => window.location.hash = `#/dog/${dog.id}`}
                  >
                    Scopri la sua storia
                  </button>
                  {!dog.is_adopted && (
                    <button 
                      className="btn btn-primary"
                      onClick={() => window.location.hash = `#/adozione/${dog.id}`}
                    >
                      Adottami
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default DogsGrid;
